/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesStatsSyncStatusResponse } from '../../models/sales-stats-sync-status-response';

export interface GetSalesStatsSyncStatus$Params {
}

export function getSalesStatsSyncStatus(http: HttpClient, rootUrl: string, params?: GetSalesStatsSyncStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesStatsSyncStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getSalesStatsSyncStatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SalesStatsSyncStatusResponse>;
    })
  );
}

getSalesStatsSyncStatus.PATH = '/sales-stats/sync-status';
